module.exports = __webpack_public_path__ + "static/media/lk.1461b40f.svg";